<template>
    <div>
        <slot v-bind="this" />
    </div>
</template>

<script>
    export default {
        props: {
            data: {
                type: Object,
                default:() => ({
                    type: null,
                })
            },
        },
        data() {
            return {
                has_license: this.data.has_license,
            }
        },
        methods: {
            handleHasLicenseChanged(value) {
                this.has_license = value;
            },
        }
    }
</script>